import { observer } from "mobx-react-lite";
import * as React from "react";
import { WidthLimitedFields } from "src/pages/ManagementPage/WidthLimitedFields";
import { ExtraTools } from "src/pages/ManagementPage/ExtraTools";
import {
  TreeActionsPort,
  TreeDataPort,
} from "src/pages/ManagementPage/objects/ports";
import { ValueO2 } from "../../Obj2Nodes";
import { UpToObject } from "../UpToObject";
import styles from "./ValueForm2.module.less";
import { AddValueItem } from "./AddValueItem";

interface PropsValueForm2 {
  store: TreeActionsPort & TreeDataPort;
  valueNode: ValueO2;
}

export const ValueForm2: React.FC<PropsValueForm2> = observer((props) => {
  const { valueNode } = props;
  return <WidthLimitedFields>{valueNode.value.name}</WidthLimitedFields>;
});

export const ValueFormButtons: React.FC<PropsValueForm2> = observer(
  ({ store, valueNode }) => (
    // Загруженность вложений значения тут не проверяется: список детей
    // догружается перед вставкой черновика (flow/drafts), поэтому ждать
    // раскрытия узла, как в v1, больше не нужно
    <div className={styles.buttons}>
      <UpToObject store={store} />
      <ExtraTools>
        <AddValueItem
          store={store}
          valueNode={valueNode}
          disabled={!valueNode.actions.update}
        />
      </ExtraTools>
    </div>
  ),
);
